// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BotMessageSquare as RawBotMessageSquare } from "lucide-react";
export const BotMessageSquare = /* @__PURE__ */ createIcon(RawBotMessageSquare, "BotMessageSquare", 2);
